// import Swiper JS
import Swiper, { Navigation } from 'swiper';

const ReceptenSlider = {
    init() {
        // configure Swiper to use modules
        Swiper.use([Navigation]);

        // init Swiper:
        new Swiper('.recepten-slider .swiper-container', {
            slidesPerView: 'auto',
            spaceBetween: 0,
            allowTouchMove: true,
            updateOnWindowResize: true,
            observer: true,
            observeParents: true,
            loop: false,
            navigation: {
                nextEl: '.recepten-slider .swiper-button-next',
                prevEl: '.recepten-slider .swiper-button-prev',
            },
        });
    },
};

export default ReceptenSlider;
